import { Navbar, Nav } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
// import LOGO_IMAGE from "../assets/logo.png";
import LOGO_MOBILE from "../assets/NAV-ICON.png"; // Add your mobile logo if you have one

const NavbarComponent = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", tag: "/" },
    { name: "Features", tag: "/features" },
    { name: "Pricing", tag: "/pricing" },
    { name: "Contact", tag: "/contact" },
  ];

  const handleGetStarted = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Landing Page Get Started (Navbar) Click',
        status: 'Initiated'
      });
    }
    window.open("https://web.daydone.co.uk/signup", "_blank");
  };

  const handleLogin = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Landing Page Sign in Click',
        status: 'Initiated'
      });
    }
    window.open("https://web.daydone.co.uk/login", "_blank");
  };

  return (
    <Navbar expand="lg" className="custom-navbar">
      <div className="navbar-wrapper">
        <div className="navbar-content">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="navbar-logo d-lg-block d-none">
            <motion.img
              src={LOGO_MOBILE}
              alt="logo"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            />
          </Navbar.Brand>

          <Navbar.Brand as={Link} to="/" className="navbar-logo d-lg-none">
            <motion.img
              src={LOGO_MOBILE}
              alt="logo"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            />
          </Navbar.Brand>

          {/* Mobile toggle button (always visible on mobile) */}
          <button
            onClick={() => setIsOpen(true)}
            className="custom-toggle d-lg-none"
            aria-label="Open Menu"
          >
            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          {/* Desktop Nav Links */}
          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-block">
            <Nav className="ms-auto gap-3 align-items-lg-center nav-container">
              <div className="desktop-nav-links d-flex gap-3 align-items-center">
                {navLinks.map((link, idx) => (
                  <motion.div
                    key={link.tag}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 + idx * 0.1 }}
                  >
                    <Nav.Link as={Link} to={link.tag} className="nav-link-item">
                      {link.name}
                    </Nav.Link>
                  </motion.div>
                ))}

                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 + navLinks.length * 0.1 }}
                >
                  <Nav.Link
                    onClick={handleLogin}
                    className="nav-link-item cursor-pointer"
                    as="span"
                  >
                    Sign in
                  </Nav.Link>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 + navLinks.length * 0.1 }}
                  className="getstarted-wrapper"
                >
                  <button className="getstarted-btn-nav" onClick={handleGetStarted}>
                    Get Started
                  </button>
                </motion.div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </div>
      </div>

      {/* Side-Sliding Mobile Menu Overlay */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <motion.div
              className="mobile-menu-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
            />
            {/* Sliding Panel */}
            <motion.div
              className="mobile-side-menu"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
            >
              <div className="mobile-menu-header">
                <img src={LOGO_MOBILE} alt="logo" className="mobile-menu-logo" />
                <button
                  className="close-menu-btn"
                  onClick={() => setIsOpen(false)}
                  aria-label="Close Menu"
                >
                  <X size={32} />
                </button>
              </div>

              <div className="mobile-menu-links">
                {navLinks.map((link) => (
                  <Nav.Link
                    key={link.tag}
                    as={Link}
                    to={link.tag}
                    className="mobile-nav-link-item"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.name}
                  </Nav.Link>
                ))}

                <div
                  onClick={() => { handleLogin(); setIsOpen(false); }}
                  className="mobile-nav-link-item cursor-pointer"
                >
                  Sign in
                </div>

                <div className="mobile-getstarted-wrapper">
                  <button
                    className="getstarted-btn-nav w-100"
                    onClick={() => { handleGetStarted(); setIsOpen(false); }}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </Navbar>
  );
};

export default NavbarComponent;